import * as React from "react";
const SvgDownload24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        fill: "black",
        viewBox: "0 0 21 21"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M10.5 15 4.29 8.79l1.42-1.41 3.79 3.79V0h2v11.17l3.79-3.79 1.42 1.41L10.5 15Z"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M.5 13h2v6h16v-6h2v8H.5v-8Z"
    })
  );
export default SvgDownload24Px;
